import { Component, inject, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { type ChildClient } from '@models';
import { Store } from '@ngrx/store';
import { ClientManagementActions } from '@ngrx-store';
import { SliderComponent } from '@ui';

@Component({
  imports: [MatCardModule, SliderComponent],
  selector: 'avs-session-timeout',
  standalone: true,
  templateUrl: './session-timeout.component.html',
})
export class SessionTimeoutComponent {
  client = input.required<ChildClient>();
  disabled = input(false);

  private store = inject(Store);

  protected onUpdate(value: number) {
    const client = this.client();

    if (value === client.clientUserSettings?.userSessionTimeoutMinutes) {
      return;
    }

    this.store.dispatch(
      ClientManagementActions.updateChildClient({
        clientClientId: client.id,
        clientData: { clientUserSettings: { ...client.clientUserSettings, userSessionTimeoutMinutes: value } },
      }),
    );
  }
}
